module.exports = __webpack_public_path__ + "static/img/mobile-karte.7dcd9ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile-karte.svg
// module id = nUxf
// module chunks = 1